<template>
  <span v-if="hasPerm">
    <slot></slot>
  </span>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CommonPermissions',
  props: {
    p: {
      type: Array,
      default: () => [0, 0]
    },
  },
  computed: {
    ...mapState({
      userData: (state) => {
        console.log(state)
        return state.security.user
      },
    })
  },
  data() {
    return {
      hasPerm: false
    }
  },
  mounted() {
    console.log('this.user')
    console.log(this.userData)
    this.checkPermissions()
  },
  methods: {
    checkPermissions() {
      console.log('checkPermissions')
      console.log(this.userData)
      if(this.userData.company.permissions[this.p[0]] & this.p[1]){
        this.hasPerm = true
      }
    }
  }
}
</script>

<style>

</style>